import { themeGet } from 'styled-system';
import styled from '@emotion/styled';
import { Flex, Link, Text } from 'roo-ui/components';

export const DestinationsMenuWrapper = styled(Flex)`
  position: absolute;
  box-shadow: ${themeGet('shadows.modal')};
  z-index: ${themeGet('zIndices.modal')};
  width: 500px;
  margin-left: -${themeGet('space.3')};
  border: solid 1px ${themeGet('colors.greys.alto')};
  border-top: 0;
  background-color: ${themeGet('colors.white')};

  &:hover {
    .nav-destinations {
      color: ${themeGet('colors.brand.primary')};
    }
  }
`;

export const DestinationColumn = styled(Flex)`
  width: 100%;
  flex-direction: column;
  padding: ${themeGet('space.6')};
  color: ${themeGet('colors.greys.steel')};
`;

export const TitleLink = styled(Link)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: solid 1px ${themeGet('colors.greys.porcelain')};
  padding-bottom: ${themeGet('space.2')};
  color: inherit;

  &:hover {
    color: ${themeGet('colors.brand.primary')};
  }
`;

export const TextTitle = styled(Text)`
  font-size: ${themeGet('fontSizes.base')};
  border-bottom: solid 1px ${themeGet('colors.greys.porcelain')};
  padding-bottom: ${themeGet('space.2')};
  color: inherit;
`;

export const DestinationPageLink = styled(Link)`
  font-size: ${themeGet('fontSizes.sm')};
  color: inherit;

  &:hover {
    color: ${themeGet('colors.brand.primary')};
  }
`;
